import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import Home from './Home';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <Home />
    </LanguageProvider>
  );
}

export default App;
